import { render, staticRenderFns } from "./clientscreen.vue?vue&type=template&id=f19061f0&"
import script from "./clientscreen.vue?vue&type=script&lang=js&"
export * from "./clientscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports